import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';

import {useProducts} from '../hooks/useProducts.ts';
import {useProductsSelection} from '../hooks/useProductsSelection.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useProductsSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchMoreRecords,
        handleFilterByKeyword
    } = useProducts();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const {columns} = useTableColumns();

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchMoreRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchMoreRecords}/>
        </SimpleGrid>
    );
};
